'use strict';

import Component from 'generic.basecomponent';


export default class PostbackButton extends Component {
    constructor(el) {
        super(el);

        this.clickHandler = this.clickHandler.bind(this);
        this.init();
    }

    init() {
        this.data = this.container.getAttribute('data-postback-button');
        this.container.addEventListener('click', this.clickHandler);
    }

    clickHandler(e) {
        console.log(this.data);
        window.__doPostBack(this.data, '');

    }

    destroy() {
        super.destroy();
        this.container.removeEventListener('click', this.clickHandler);
    }
}



// WEBPACK FOOTER //
// ./app/components/postback-button/js/generic.postback-button.js